import { useState } from "react";

const getMediaType = (url) => {
  if (!url) return null;
  const cleanUrl = url.split("?")[0].toLowerCase();

  if (/\.(jpg|jpeg|png|gif|webp|svg)$/.test(cleanUrl)) return "image";
  if (/\.(mp3|wav|ogg|aac|m4a)$/.test(cleanUrl)) return "audio";
  if (/\.(mp4|webm|mov|mkv)$/.test(cleanUrl)) return "video";

  return "unknown";
};

export function MediaWithDescription({
  mediaUrl,
  ZoomComponent,
  children,
}) {
  const [open, setOpen] = useState(false);
  const [loaded, setLoaded] = useState(false);

  const mediaType = getMediaType(mediaUrl);

  const renderMedia = () => {
    if (!mediaUrl) return null;

    if (mediaType === "image") {
      const img = <img src={mediaUrl} alt="media" />;
      return ZoomComponent ? <ZoomComponent>{img}</ZoomComponent> : img;
    }

    if (mediaType === "audio") {
      return <audio controls src={mediaUrl} />;
    }

    if (mediaType === "video") {
      return <video controls src={mediaUrl} />;
    }

    return null;
  };

  return (
    <>
      <div className={`mwd ${mediaUrl ? "mwd--with-media" : "mwd--no-media"}`}>
        {mediaUrl && (
          <div
            className="mwd__media"
            onClick={() => {
              setOpen(true);
              setLoaded(true); // mark as loaded once opened
            }}
          >
            <div className="mwd__preview">
              {mediaType === "image" && "🖼 View"}
              {mediaType === "audio" && "🎧 Play"}
              {mediaType === "video" && "▶ Watch"}
            </div>
          </div>
        )}

        <div className="mwd__content">{children}</div>
      </div>

      {/* MODAL */}
      {open && (
        <div className="mwd__modal">
          <div className="mwd__modal-overlay" onClick={() => setOpen(false)} />

          <div className="mwd__modal-content">
            <button
              className="mwd__close"
              onClick={() => setOpen(false)}
            >
              ✕
            </button>

            {/* IMPORTANT: Only render after first open, but KEEP mounted */}
            {loaded && renderMedia()}
          </div>
        </div>
      )}
    </>
  );
}